var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.cssClass},[_c('div',{staticClass:"ribbon-item"},[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }